import styled from 'styled-components'
import { space } from 'styled-system'
import { PackagesProps } from './Packages'

export const StyledPackages = styled.div<PackagesProps>`
  display: flex;
  flex-wrap: ${props => (props.variant !== 'alternative' ? 'wrap' : 'no-wrap')};
  ${props => props.variant === 'alternative' && 'flex-direction: column'};
  justify-content: flex-start;
  width: ${props => (props?.fullWidth ? '100%' : 'auto')};
  ${space}

  & > section {
    margin-bottom: ${props => props.theme.spacing.medium};
    margin-top: auto;

    &:not(:last-of-type) {
      margin-right: ${props => props.theme.spacing.default};
    }
  }

  div[role='hoverComponent'] {
    z-index: 5;
    padding: 1rem;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border: 1px solid #ddddff;
    border-radius: 0.25rem;
    width: 150%;
  }
`

export const HoverWrapper = styled.div`
  margin-bottom: 1rem;
`
